const PLACEHOLDER_BARCODES = new Set(['NO']);

export function isPlaceholderBarcode(value) {
  return PLACEHOLDER_BARCODES.has(String(value || '').trim().toUpperCase());
}

export function cleanBarcodeForSave(value) {
  const text = String(value || '').trim();
  return isPlaceholderBarcode(text) ? '' : text;
}
